import React from 'react';

import { currencyString } from '@consumer-frontend/nc-utils';

export type NcCustomAmountLabelPropsT = {
  amount?: number;
};

export type NcCustomAmountLabelT = React.FC<NcCustomAmountLabelPropsT>;

export const NcCustomAmountLabel: NcCustomAmountLabelT = ({ amount }) => {
  return (
    <div className="nc-custom-amount-label">
      <p className="payment-amount-option-label">
        <span className="label-clickable-elements">
          Custom amount
        </span>
        {!!amount && <span className="currency-amount">{currencyString(amount)}</span>}
      </p>

      {amount && (
        <p className="nc-button custom-amount-update-button btn btn-link">
          Update
        </p>
      )}
    </div>
  );
};
